/**
 * Created by vladislav on 9/5/2025
 */

const Map2dScrollView = cleverapps.UI.ScrollView.extend({
    ctor: function (scroller, content, options) {
        this.scroller = scroller;

        this._super(content, options);

        this.setClippingEnabled(false);
        this.isMapScroll = true;
        this.debugId = "Scroll";

        this.touchZoomDisabled = true;
        this.touchScrollDisabled = true;

        this.scroller.onDiscoverScrollView = () => this;
        this.scroller.getScrollZoom = () => this.zoomHandler.normalizeZoom(this.zoom);
        this.scroller.isScrollProcessing = this.createListener(this.scrollHandler.isProcessing());
        this.scroller.onFocusOnUnit = this.createListener(this.focusOnUnit.bind(this));
        this.scroller.onFocusOnTarget = this.createListener(this.focusOnTarget.bind(this));
        this.scroller.onExploreArea = this.createListener(this.exploreArea.bind(this));

        this.setLocalZOrder(-1);
        this.updateVisibility();

        this.zoomHandler.setZoom((cleverapps.silentIntro ? 1 : 0.8) * Map2dScroller.currentScroller.getBasicZoom(), true);

        this.onUpdatePositionListener = this.onUpdateZoomListener = this.createListener(() => {
            this.scroller.onPositionChangedListener();
        });

        this.toggleScroll = this.createListener((enabled) => {
            this.touchScrollDisabled = !enabled;
        });
        cleverapps.focusManager.registerControl("map2dScroll", this.toggleScroll);

        this.toggleZoom = this.createListener((enabled) => {
            this.touchZoomDisabled = !enabled;
        });
        cleverapps.focusManager.registerControl("map2dZoom", this.toggleZoom);
    },

    focusOnUnit: function (unit, options = {}) {
        const actions = [];

        if (options.zoom) {
            actions.push(new cc.ZoomAction(options.zoom.duration, { zoom: options.zoom.zoom }));
        }

        actions.push(
            new cc.CellScrollAction(unit, {
                allowScrollWithFocus: options.allowScrollWithFocus,
                duration: options.duration,
                skipFocusReport: options.skipFocusReport,
                visibleBox: options.visibleBox
            }).easing(cc.easeInOut(2)),
            new cc.CallFunc(() => {
                if (options.finger) {
                    FingerView.hintTap(unit, {
                        delay: options.finger.delay || 0.5,
                        runOnce: true
                    });
                }
                options.action && options.action();
            }),
            new cc.DelayTime(options.delay || 0),
            new cc.CallFunc(() => {
                if (options.callback) {
                    options.callback();
                }
            })
        );

        this.runAction(new cc.Sequence(actions));
    },

    focusOnTarget: function (target, options = {}) {
        this.runAction(new cc.Sequence(
            new cc.ScrollAction(target, {
                allowScrollWithFocus: options.allowScrollWithFocus,
                duration: options.duration,
                skipFocusReport: options.skipFocusReport
            }).easing(cc.easeInOut(2)),
            new cc.CallFunc(() => {
                if (options.callback) {
                    options.callback();
                }
            })
        ));
    },

    exploreArea: function (fakeUnit, callback) {
        this.runAction(new cc.Sequence(
            new cc.ZoomAction(0.7, { zoom: 0.6 }),
            new cc.CellScrollAction(fakeUnit, {
                allowScrollWithFocus: true
            }).easing(cc.easeInOut(2)),
            new cc.DelayTime(0.4),
            new cc.ZoomAction(0.8, {
                zoom: 0.9,
                zoomFocus: Map2d.currentMap.getMapView().getCell(fakeUnit.x, fakeUnit.y)
            }),
            new cc.Spawn(
                new cc.Sequence(
                    new cc.DelayTime(2),
                    new cc.CallFunc(() => {
                        cleverapps.centerHint.createTextHint(Messages.get("Fog.explore"));
                    })
                ),
                new cc.CellScrollAction({
                    x: fakeUnit.x + 20,
                    y: fakeUnit.y + 20
                }, {
                    duration: 6,
                    allowScrollWithFocus: true
                }).easing(cc.easeInOut(1))
            ),
            new cc.CallFunc(callback)
        ));
    }
});